var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiveVidIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_78496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6.66577L13.0353 5.14844C13.1369 5.09766 13.2499 5.07369 13.3633 5.0788C13.4768 5.08391 13.5871 5.11793 13.6837 5.17764C13.7804 5.23735 13.8602 5.32075 13.9155 5.41995C13.9709 5.51915 13.9999 5.63084 14 5.74444V10.2538C13.9999 10.3674 13.9709 10.4791 13.9155 10.5783C13.8602 10.6775 13.7804 10.7609 13.6837 10.8206C13.5871 10.8803 13.4768 10.9143 13.3633 10.9194C13.2499 10.9245 13.1369 10.9005 13.0353 10.8498L10 9.33244V6.66577Z",
    stroke: "#0E5B48",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 4H3.33333C2.59695 4 2 4.59695 2 5.33333V10.6667C2 11.403 2.59695 12 3.33333 12H8.66667C9.40305 12 10 11.403 10 10.6667V5.33333C10 4.59695 9.40305 4 8.66667 4Z",
    stroke: "#0E5B48",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_78496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveVidIcon);
export default __webpack_public_path__ + "static/media/liveVidIcon.0fa3ee4c86cacff11e69d0acfa9cdbc2.svg";
export { ForwardRef as ReactComponent };